
define('known/views/sideNavView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'unknown/models/loginModel',
	'unknown/models/registerModel',
	'known/collections/productCollection',
	'known/collections/leagueInstanceCollection',
	
	//Shims
	'jquery.collapsible',
	'jquery.sha256'
], function($, _, Backbone, UserModel, LoginModel, RegisterModel, ProductCollection, LeagueInstanceCollection){
	var LoginRegisterFooterView = Backbone.View.extend({
		events: {
			'click #sideNavLoginRegSubmitBtn': 'submitLoginForm'
		},
		
		initialize: function(options) {
			this.event = options.event;
			
			this.showForm();
			
			this.listenTo(this.event, 'default', this.showForm);
			this.listenTo(this.event, 'loggingIn', this.showNonForm);
			this.listenTo(this.event, 'error', this.showForm);
			this.listenTo(this.event, 'error:notAuthorized', this.showForm);
		},
		
		submitLoginForm: function () {
			this.event.trigger("save");
		},
		
		showForm: function () {
			this.$("#sideNavLoginRegSubmitBtn").show();
		},
		
		showNonForm: function () {
			this.$("#sideNavLoginRegSubmitBtn").hide();
		},
	});

	var LoginRegisterContentView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.loginModel = options.loginModel;
			this.registerModel = options.registerModel;
			this.event = options.event;
			this.submittedData = options.submittedData;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			_.bindAll(this, 'loginTypeChange');
			_.bindAll(this, 'formEnter');
			
			this.listenTo(this.event, 'save', this.submitLogin);
			this.listenTo(this.event, 'loggingIn', this.hideAll);
			this.listenTo(this.event, 'default', this.form);
			this.listenTo(this.event, 'error', this.form);
			this.listenTo(this.event, 'error:notAuthorized', this.form);
			
			//Error handling
			this.listenTo(this.event, 'error:logintype', this.errorLoginType);
			this.listenTo(this.event, 'error:username', this.errorUsername);
			this.listenTo(this.event, 'error:password', this.errorPassword);
			this.listenTo(this.event, 'error:email', this.errorEmail);
						
			this.$("input[name='sideNavLoginRegType']").change(this.loginTypeChange);
			$('#sideNavLoginRegBodyContentForm').on("keyup", this.formEnter);
		},
		
		submitLogin: function () {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("loggingIn");
				
				if(this.$("input[name='sideNavLoginRegType']:checked").val() == 'LOGIN'){
					//Attempt to login user
					this.submittedData.isSubmitted = true;
					
					this.loginModel.save({
						userName: this.$("#sideNavLoginRegUserNameInput").val(),
						password : this.$("#sideNavLoginRegPassInput").val() ? $.sha256(this.$("#sideNavLoginRegPassInput").val()) : ""
					},{wait: true,
						success : this.successCallback, 
						error : this.errorCallback
					});
				} else if(this.$("input[name='sideNavLoginRegType']:checked").val() == 'REGISTER'){
					//Attempt to register user
					var submittable = false;
					var username = this.$("#sideNavLoginRegUserNameInput").val();
					var email = this.$("#sideNavLoginRegEmailInput").val();
					
					if(this.$("#sideNavLoginRegPassInput").val()){
						if(this.$("#sideNavLoginRegPassInput").val() == username){
							this.event.trigger("error");
							this.event.trigger("error:password", "SAME");
						} else if (this.$("#sideNavLoginRegPassInput").val().length < 5) {
							this.event.trigger("error");
							this.event.trigger("error:password", "LENGTH");
						} else {
							submittable = true;
						} 
					} else {
						submittable = true;
					}
										
					if(submittable){
						this.submittedData.isSubmitted = true;
						this.registerModel.save({
							userName: username,
							password : this.$("#sideNavLoginRegPassInput").val() ? $.sha256(this.$("#sideNavLoginRegPassInput").val()) : "",
							email: email
						},{wait: true,
							success : this.successCallback, 
							error : this.errorCallback
						});	
					}
				} else {
					//problem with the radio input
					this.event.trigger("error");
					this.event.trigger("error:logintype", "NULL");
				}
			}
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},

		formEnter: function(e) {
			var code = e.keyCode || e.which; 
			if (code  == 13) {               
				e.preventDefault();
				this.event.trigger("save");
				return false;
			}
		},
		
		loginTypeChange: function() {
			if (this.$("input[name='sideNavLoginRegType']:checked").val() == 'LOGIN') {
				this.$("#sideNavLoginRegEmailGrp").hide();
			} else if (this.$("input[name='sideNavLoginRegType']:checked").val() == 'REGISTER') {
				this.$("#sideNavLoginRegEmailGrp").show();
			} else {
				this.$("#sideNavLoginRegEmailGrp").hide();
			}
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			//Hide error messages
			this.$("#sideNavLoginRegTypeGrp").removeClass("error");
			this.$("#sideNavLoginRegTypeErrMsg").hide();
			
			this.$("#sideNavLoginRegUserNameGrp").removeClass("error");
			this.$("#sideNavLoginRegUserNameInput").removeClass("error");
			this.$("#sideNavLoginRegUserNameErrMsg").hide();
			
			this.$("#sideNavLoginRegPassGrp").removeClass("error");
			this.$("#sideNavLoginRegPassInput").removeClass("error");
			this.$("#sideNavLoginRegPassErrMsg").hide();
			
			this.$("#sideNavLoginRegEmailGrp").removeClass("error");
			this.$("#sideNavLoginRegEmailInput").removeClass("error");
			this.$("#sideNavLoginRegEmailErrMsg").hide();
		},
		
		form: function () {
			this.hideAll();
			this.loginTypeChange();
			$(this.el).show();
		},
		
		errorLoginType : function (errorCode) {
			this.$("#sideNavLoginRegTypeGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#sideNavLoginRegTypeErrMsg").html("Sign In type is empty");
					this.$("#sideNavLoginRegTypeErrMsg").show();
					break;
				default : 
					this.$("#sideNavLoginRegTypeErrMsg").html("Sign In type is invalid");
			}
		},
		
		errorUsername : function (errorCode) {
			this.$("#sideNavLoginRegUserNameGrp").addClass("error");
			this.$("#sideNavLoginRegUserNameInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#sideNavLoginRegUserNameErrMsg").html("Username is empty");
					this.$("#sideNavLoginRegUserNameErrMsg").show();
					break;
				case "LENGTH": 
					this.$("#sideNavLoginRegUserNameErrMsg").html("Username must be between 5 and 20 characters long");
					this.$("#sideNavLoginRegUserNameErrMsg").show();
					break;
				case "ALPHANUM": 
					this.$("#sideNavLoginRegUserNameErrMsg").html("Username may only contain alpha numeric characters");
					this.$("#sideNavLoginRegUserNameErrMsg").show();
					break;
				case "USEREXISTS": 
					this.$("#sideNavLoginRegUserNameErrMsg").html("User has already been created");
					this.$("#sideNavLoginRegUserNameErrMsg").show();
					break;
				case "NOTAUTH": 
					break;
				default : 
					this.$("#sideNavLoginRegUserNameErrMsg").html("Username is invalid");
			}
		},
		
		errorPassword : function (errorCode) {
			this.$("#sideNavLoginRegPassGrp").addClass("error");
			this.$("#sideNavLoginRegPassInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#sideNavLoginRegPassErrMsg").html("Password is empty");
					this.$("#sideNavLoginRegPassErrMsg").show();
					break;
				case "LENGTH": 
					this.$("#sideNavLoginRegPassErrMsg").html("Password must be at least 5 characters long");
					this.$("#sideNavLoginRegPassErrMsg").show();
					break;
				case "SAME": 
					this.$("#sideNavLoginRegPassErrMsg").html("Password must not match the user name");
					this.$("#sideNavLoginRegPassErrMsg").show();
					break;
				case "NOTAUTH": 
					break;
				default : 
					this.$("#sideNavLoginRegPassErrMsg").html("Password is invalid");
			}
		},
		
		errorEmail: function(errorCode) {
			this.$("#sideNavLoginRegEmailGrp").addClass("error");
			this.$("#sideNavLoginRegEmailInput").addClass("error");
			
			switch (errorCode){
				case "NULL": 
					this.$("#sideNavLoginRegEmailErrMsg").html("Email is empty");
					this.$("#sideNavLoginRegEmailErrMsg").show();
					break;
				case "EMAIL": 
					this.$("#sideNavLoginRegEmailErrMsg").html("Invalid email address");
					this.$("#sideNavLoginRegEmailErrMsg").show();
					break;
				case "NOTEQUAL":
					this.$("#sideNavLoginRegEmailErrMsg").html("Email must match the confirmatin email address");
					this.$("#sideNavLoginRegEmailErrMsg").show();
					break;
				case "EMAILEXISTS":
					this.$("#sideNavLoginRegEmailErrMsg").html("Email has already been registered");
					this.$("#sideNavLoginRegEmailErrMsg").show();
					break;
				default : 
					this.$("#sideNavLoginRegEmailErrMsg").html("Invalid email address");
			}
		}
	});

	var LoginRegisterMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'loggingIn', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'error:notAuthorized', this.notAuthorized);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$("#sideNavLoginRegMessageError").hide();
			this.$("#sideNavLoginRegMessageNotAuthorized").hide();
			this.$("#sideNavLoginRegMessageProcessing").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#sideNavLoginRegMessageError").show();
		},
		
		notAuthorized: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#sideNavLoginRegMessageNotAuthorized").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#sideNavLoginRegMessageProcessing").show();
		},
	});
	
	var LoginRegisterView = Backbone.View.extend({
		el: $("#sideNavLoginReg"),
		
		initialize: function(options) {
			this.userModel = options.userModel;
			this.loginModel = new LoginModel();
			this.registerModel = new RegisterModel();
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			_.bindAll(this, 'successCallback');
			
			this.message = new LoginRegisterMessageView({el: this.$("#sideNavLoginRegMessage"), event: this.event});
			this.content = new LoginRegisterContentView({
				el: this.$("#sideNavLoginRegBodyContentForm"), 
				event: this.event , 
				loginModel: this.loginModel,
				registerModel: this.registerModel,
				submittedData: this.submittedData});
			this.footer = new LoginRegisterFooterView({el: this.$("#sideNavLoginRegFooter"), event: this.event});
			
			this.listenTo(this.event, 'savingSuccess', this.success);
			this.listenTo(this.event, 'savingError', this.error);
		},
		
		render: function () {
			this.event.trigger("default");
			return this;
		},
		
		error: function(model, error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else if (error.status == 401) {
					//Username/pass invalid
					this.event.trigger("error:notAuthorized");
					this.event.trigger("error:username", "NOTAUTH");
					this.event.trigger("error:password", "NOTAUTH");
				} else if (error.status == 409) {
					//Email already registered
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);			
					if(errObj.message && errObj.message.toLowerCase().indexOf("email") > -1){
						//Email already activated
						this.event.trigger("error:email", "EMAILEXISTS");
					} else if(errObj.message && errObj.message.toLowerCase().indexOf("user") > -1) {
						//User already activated
						this.event.trigger("error:username", "USEREXISTS");
					}
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		}, 
		
		success: function () {
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				
				if (this.$("input[name='sideNavLoginRegType']:checked").val() == 'LOGIN') {
					this.userModel.set({userName: this.loginModel.get('userName').toLowerCase()});
				} else if (this.$("input[name='sideNavLoginRegType']:checked").val() == 'REGISTER') {
					this.userModel.set({userName: this.registerModel.get('userName').toLowerCase()});
				}
				
				this.userModel.fetch({success: this.successCallback});
			}
			return this;
		},
		
		successCallback: function(model, response) {
			this.$("#sideNavLoginRegUserNameInput").val('');
			this.$("#sideNavLoginRegPassInput").val('');
			this.$("#sideNavLoginRegEmailInput").val('');
			this.event.trigger("default");
		},
	});
	
	
	
	
	var SideNavLeagueSummaryView = Backbone.View.extend({
		el: $("#sideNavLgSummary"),
		
		initialize: function(options) {
			this.leagueCollection = options.leagueCollection;
			this.listenTo(this.leagueCollection, 'sync', this.render);
			this.listenTo(this.leagueCollection, 'remove', this.render);
			this.listenTo(this.leagueCollection, 'add', this.render);
			this.template = _.template($('#navLeaguesTemplate').html().trim());
		},
		
		render: function () {
			var startedOrPredraftLgs = this.leagueCollection.getStartedOrPredraftLeagues();
			var setupLgs = this.leagueCollection.getSetupLeagues();
			var completedLgs = this.leagueCollection.getCompletedLeagues();
			
			this.$el.find('#sideNavStartedNum').html(startedOrPredraftLgs.length);
			this.$el.find('#sideNavSetupNum').html(setupLgs.length);
			this.$el.find('#sideNavCompletedNum').html(completedLgs.length);
			
			if(startedOrPredraftLgs.length > 0){
				this.$el.find("#sideNavStartedList").empty();
				
				_.each(startedOrPredraftLgs, function(league) {
					var link = "/draftapp/board/"
						+ league.get("id");
				
					var curLgItem = $(this.template({
						lgName: league.prettyDispName(),
						link: link
					}));
					
					this.$el.find("#sideNavStartedList").append(curLgItem);
				}, this);
			} else {
				this.$el.find("#sideNavStartedList").html('<li><a href="#" title="">No drafts completed</a></li>');
			}
			
			if(setupLgs.length > 0){
				this.$el.find("#sideNavSetupList").empty();
				
				_.each(setupLgs, function(league) {
					var link = "/draftapp/dashboard/leagues/"
						+ league.get("leagueId")
						+ "/instances/"
						+ league.get("id");
					
					var curLgItem = $(this.template({
						lgName: league.prettyDispName(),
						link: link
					}));
					
					this.$el.find("#sideNavSetupList").append(curLgItem);
				}, this);
			} else {
				this.$el.find("#sideNavSetupList").html('<li><a href="#" title="">No drafts completed</a></li>');
			}
			
			if(completedLgs.length > 0){
				this.$el.find("#sideNavCompletedList").empty();
				
				_.each(completedLgs, function(league) {
					var link = "/draftapp/board/"
						+ league.get("id");
				
					var curLgItem = $(this.template({
						lgName: league.prettyDispName(),
						link: link
					}));
					
					this.$el.find("#sideNavCompletedList").append(curLgItem);
				}, this);
			} else {
				this.$el.find("#sideNavCompletedList").html('<li><a href="#" title="">No drafts completed</a></li>');
			}
			
			
			
			return this;
		}
	});
	
	var SideNavActionsView = Backbone.View.extend({
		el: $("#sideNavQuickActions"),
		
		initialize: function(options) {
			this.prodCollection = options.prodCollection;
			this.user = options.user;
			//this.listenTo(this.prodCollection, 'sync', this.render);
			
			this.prodCollection.each(function(product) {
				product.get("productTypes").each(function(productType) {
					this.listenTo(productType, 'change', this.render);
				}, this);
			}, this);
		},
		
		render: function () {
			var activeProds = this.prodCollection.activeProducts();
			
			if(!this.user.isGuest() && activeProds && activeProds.length > 0){
				this.$el.show();
				this.$el.find('#sideNavJoinBtn').show();
				
				var usableProds = this.prodCollection.activeUsableProducts();
				var purchasableProds = this.prodCollection.activePurchasableProducts();
				
				if(usableProds && usableProds.length > 0){
					this.$el.find('#sideNavCreateBtn').show();
				} else {
					this.$el.find('#sideNavCreateBtn').hide();
				}
				
				if(purchasableProds && purchasableProds.length > 0){
					this.$el.find('#sideNavPurchBtn').show();
				} else {
					this.$el.find('#sideNavPurchBtn').hide();
				}
			} else {
				this.$el.hide();
				this.$el.find('#sideNavJoinBtn').hide();
				this.$el.find('#sideNavCreateBtn').hide();
				this.$el.find('#sideNavPurchBtn').hide();
			}
			
			return this;
		}
	});
	
	var SideNavProductView = Backbone.View.extend({
		initialize: function(options) {
			this.product = options.product;
			
			this.firstRender = true;
			
			this.product.get("productTypes").each(function(productType) {
				this.listenTo(productType, 'change', this.render);
			}, this);
			
			this.template = _.template($('#navProductsTemplate').html().trim());
		},
		
		render: function () {
			var purchasableClass = "hide";
			var activeClass = "hide";
			var usableClass = "hide";
			var trialClass = "hide";
			var listItemCount = 1;
			
			if(_.size(this.product.activeProducts()) > 0){
				activeClass = "";
				listItemCount += 3;
				
				if(_.size(this.product.activeUsableProducts()) > 0){
					usableClass = "";
					listItemCount += 1;
				}
				
				if(_.size(this.product.activePurchasableProducts()) > 0){
					purchasableClass = "";
					trialClass = "";
					listItemCount += 2;
				}
			}
			
			var curEl = $(this.el);
			var newEl = $(this.template({
				lgName: this.product.get("sport"),
				sportYr: this.product.get("year"),
				itemCount: listItemCount,
				purchasableClass: purchasableClass,
				activeClass: activeClass,
				usableClass: usableClass,
				trialClass: trialClass
			}));
			
			this.setElement(newEl);
			
			if(!this.firstRender){
				curEl.replaceWith(newEl);
			} else {
				this.firstRender = false;
			}	
			
			$(this.el).find('.expand').collapsible({
				cssClose: 'subClosed',
			    cssOpen: 'subOpened',
			    cookieName: 'navAct',
			    defaultOpen: '',
			    speed: 200
			});
			
			return this;
		},
		
		close:function () {
	        this.$el.remove();
	    }
	});
	
	var SideNavView = Backbone.View.extend({
		el: $("#sidebar"),
		
		initialize: function(options) {
			this.user = options.user;
			this.prodCollection = options.prodCollection;
			this.leagueCollection = options.leagueCollection;
			
			this.actionView = new SideNavActionsView({prodCollection: this.prodCollection, user: this.user});
			this.lgSummaryView = new SideNavLeagueSummaryView({leagueCollection: this.leagueCollection});
			this.loginRegView = new LoginRegisterView({userModel: this.user});
			
			
			this.prodViews = [];
			
			this.listenTo(this.user, 'change', this.renderUserName);
			this.listenTo(this.user, 'change:userName', this.updateNav);
		},
		
		render: function () {
			this.loginRegView.render();
			
			this.updateNav();
			this.actionView.render();			
			this.lgSummaryView.render();
			
			this.addAllProducts();
			
			return this;
		},
		
		updateNav: function() {
			this.renderUserName();
			
			if(this.user.isGuest()){
				this.$el.find("#sideNavLoginReg").show();
				this.$el.find("#sideNavLgList").hide();
				this.$el.find("#sideNavQuickActions").hide();
				this.$el.find("#sideNavProdLinks").hide();
			} else {
				this.$el.find("#sideNavLoginReg").hide();
				this.$el.find("#sideNavLgList").show();
				this.$el.find("#sideNavQuickActions").show();
				this.$el.find("#sideNavProdLinks").show();
			}
		},
		
		renderUserName: function () {
			this.$el.find("#sideNavUserNav").html(this.user.prettyDispName());
		},
		
		addProduct: function(product) {
			var view = new SideNavProductView({product: product});
			this.$el.find("#sideNavProdList").append(view.render().el);
			this.prodViews[product.cid] = view;
		},
		
		addAllProducts: function() {
			this.prodCollection.each(function(product){
				this.addProduct(product);
			}, this);
		},
	});
	
	return SideNavView;  
});